import { CompassOutlined, EnvironmentOutlined, PhoneOutlined } from "@ant-design/icons";
import { Col, Row, Typography } from "antd";
import CompanyLogo from "components/CompanyLogo/CompanyLogo";
import useViewport from "components/UseViewport/UseViewport";
import { Company } from "interfaces/companies";
import CompanyCard from "./CompanyCard";

const { Title, Text } = Typography;

interface Props {
  company: Company;
}

const CompanyCardAbout: React.FC<Props> = ({ company }) => {
  const { name, logo, id, url: companyUrl, region, country, telephone } = company;

  const url = !companyUrl ? null : companyUrl.includes("http") ? companyUrl : `https://${companyUrl}`;

  const location = region || country || null;
  const { width } = useViewport();
  const breakpoint = 900;

  return (
    <>
      <CompanyCard title="Om bedriften">
        <Row gutter={10}>
          <Col span={6}>
            <CompanyLogo size="95%" companyId={id} src={logo} />
          </Col>
          <Col span={18}>
            <Row style={{ paddingBottom: "10px" }}>
              <Title level={width < breakpoint ? 3 : 1} style={{ margin: 0 }}>
                {name}
              </Title>
            </Row>
            <Row gutter={[10, 5]}>
              {url ? (
                <Col>
                  <Text>
                    <a href={url}>
                      <CompassOutlined /> {url}
                    </a>
                  </Text>
                </Col>
              ) : null}
              {location ? (
                <Col>
                  <Text>
                    <EnvironmentOutlined />
                    {` ${location}`}
                  </Text>
                </Col>
              ) : null}
              {telephone ? (
                <Col>
                  <Text>
                    <PhoneOutlined />
                    {` ${telephone}`}
                  </Text>
                </Col>
              ) : null}
            </Row>
          </Col>
        </Row>
      </CompanyCard>
    </>
  );
};

export default CompanyCardAbout;
